module.exports = __webpack_public_path__ + "static/media/Guide.f1be25bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/NewTimeline/assets/Guide.svg
// module id = 263
// module chunks = 0